<template>
  <div class="agent-withdraw-body">
    <div class="agent-withdraw-nav">
      <navbar navbackgroundcolor="#FFFFFF" :lefticon="back_black_icon" :lefticonshow="true" title="余额提现" titlecolor="#1B1A2E" @goback="goBack" :fontweight="500" />
    </div>
    <div class="agent-withdraw-first-div" @click="pay_account_pup_show=true">
      <div>选择提现方式</div>
      <div v-show="pay_channel"><img :src="pay_channel == 'alipay' ? alipay_icon : wepay_icon" alt=""><span>{{change_pay_account}}</span></div>
      <img class="arrow-right" :src="arrow_right_black_icon" alt="">
    </div>
    <div class="agent-withdraw-div">
      <div class="agent-withdraw-text">提现金额</div>
      <div class="agent-withdraw-input-div">
        <span class="agent-withdraw-input-symbol">￥</span>
        <span class="agent-withdraw-input-span">
          <commoninput type="text" :fontWeight="500" fontSize="18px" :readonly="true" :disable-blur="true" :placeholder="withdraw_placeholder" :value.sync="withdrawal_amount" dointLimit="2" @input="withdrawinput" />
        </span>
        <span class="all-withdraw-btn" @click=" withdrawal_amount=balance">全部提现</span>
      </div>
    </div>
    <div class="withdraw-text">*秒杀余额提现系统自动审核到账</div>
    <div class="custom-keyboard-div">
      <baseCommonKeyboard @inpiut="handleInput" :maxLength="8" />
      <div class="submit-btn" @click="readySubmit">提交</div>
    </div>
    <van-popup v-model="pay_account_pup_show" position="bottom" :style="{ height: '25%' }" round>
      <div class="account-pup-title">选择提现方式</div>
      <div class="account-item-div" @click="changeWidthdrawChannel('alipay')">
        <div class="account-left-div">
          <img :src="alipay_account ? alipay_icon : alipay_gray_icon" alt="">
          <span>支付宝{{alipay_account}}</span>
        </div>
        <div class="account-right-div">
          <span v-show="!alipay_account">去绑定</span>
          <img class="arrow-right" :src="arrow_right_black_icon" alt="">
        </div>
      </div>
      <div class="account-item-div" @click="changeWidthdrawChannel('wx')">
        <div class="account-left-div">
          <img :src="wx_account ? wepay_icon : wepay_gray_icon" alt="">
          <span>微信{{wx_account}}</span>
        </div>
        <div class="account-right-div">
          <span v-show="!wx_account">去绑定</span>
          <img class="arrow-right" :src="arrow_right_black_icon" alt="">
        </div>
      </div>
    </van-popup>
    <basePasswordBox ref="passwordBoxRef" :isshow.sync="pay_password_show" @submit="withdrawApply" />
    <centerrscreenloading :loading="page_loading" :zIndex="zIndex" />
  </div>
</template>

<script>
  import baseCommonKeyboard from '@/components/base-common-keyboard';
  import basePasswordBox from '@/components/base-password-box';
  import navbar from '@/components/nav-bar';
  import centerrscreenloading from '@/components/centerrscreen-loading.vue'
  import commoninput from '@/components/common-input';
  import { Toast } from "vant";
  import {
    apiGetFinanceWithdrawAccount,
    apiFinanceMembernNewSpikeWithdraw
  } from './api'
  export default {
    components: {
      navbar,
      baseCommonKeyboard,
      basePasswordBox,
      commoninput,
      centerrscreenloading
    },
    data () {
      return {
        back_black_icon: require("@/assets/groupRob/back-black-icon.png"),
        arrow_right_black_icon: require("@/assets/groupRob/arrow-right-black-icon.png"),
        alipay_icon: require("@/assets/groupRob/alipay-icon.png"),
        wepay_icon: require("@/assets/groupRob/wepay-icon.png"),
        alipay_gray_icon: require("@/assets/groupRob/alipay-gray-icon.png"),
        wepay_gray_icon: require("@/assets/groupRob/wepay-gray-icon.png"),
        isIosX: false,
        withdrawal_amount: '',
        balance: '',
        withdrawReq: false,
        isIos: false,
        withdraw_placeholder: "当前余额 ¥0.00",
        pay_account_pup_show: false,
        pay_password_show: false,
        page_loading: true,
        alipay_account: '',
        wx_account: "",
        pay_channel: '',
        change_pay_account: '',
        zIndex: 8
      }
    },
    created () {
      this.isIosX = this.isIphoneX()
      this.balance = this.$route.query.spike_balance
      if (Number(this.balance)) {
        this.withdraw_placeholder = `当前余额 ¥${this.balance}`
      }
      this.userType = this.$route.query.type == 'promoter' ? '代理人' : '合伙人'
      apiGetFinanceWithdrawAccount().then((res) => {
        if (res.alipay.length) {
          this.alipay_account = res.alipay.length ? res.alipay[0].account_no.slice(0, 3) + '****' + res.alipay[0].account_no.slice(7, 11) : ''
          this.change_pay_account = '支付宝' + this.alipay_account
          this.pay_channel = 'alipay'
        }
        if (res.wx.length) {
          this.wx_account = res.wx.length ? '（' + res.wx[0].account_name + '）' : ''
          if (!res.alipay.length) {
            this.change_pay_account = '微信' + this.wx_account
            this.pay_channel = 'wx'
          }
        }
        this.page_loading = false
      }).catch(() => {
        this.page_loading = false
      })
    },
    methods: {
      changeWidthdrawChannel (text) {
        if (text == 'alipay') {
          if (this.alipay_account) {
            this.pay_channel = text
            this.change_pay_account = '支付宝' + this.alipay_account
          } else {
            Toast('请到”我的-设置-个人账户“中绑定渠道')
          }
        } else if (text == 'wx') {
          if (this.wx_account) {
            this.pay_channel = text
            this.change_pay_account = '微信' + this.wx_account
          } else {
            Toast('请到”我的-设置-个人账户“中绑定渠道')
          }
        }
        this.pay_account_pup_show = false
      },
      withdrawinput (value) {
        let valueList = String(value).split('.')
        if (valueList.length > 1 && valueList[1].length > 2) {
          this.withdrawal_amount = Number(valueList[0] + '.' + valueList[1].substring(0, 2)) * 1
        }
      },
      withdrawApply (password) {
        if (this.withdrawReq) return
        this.zIndex = 12
        this.page_loading = true
        this.withdrawReq = true
        let params = {
          "money": this.withdrawal_amount,
          "channel": this.pay_channel,
          "traders_password": password
        }
        apiFinanceMembernNewSpikeWithdraw(params).then(() => {
          this.zIndex = 8
          this.pay_password_show = false
          this.withdrawReq = false
          this.page_loading = false
          Toast('提现成功')
          this.goBack()
        }).catch((err) => {
          this.zIndex = 8
          this.$refs.passwordBoxRef.clear()
          this.withdrawReq = false
          this.page_loading = false
          if (err.response.data.code == 'CHECK_ERROR') {
            Toast(err.response.data.message)
          } else {
            Toast(err.response.data.message)
          }
        })
      },
      handleInput (value) {
        this.withdrawal_amount = value
      },
      readySubmit () {
        if (this.withdrawal_amount == '') {
          return Toast('请输入提现金额')
        } else if (Number(this.withdrawal_amount) > this.balance) {
          return Toast('提现金额不能大于可提现金额')
        } else if (this.pay_channel == '') {
          return Toast('请选择提现方式')
        } else if (Number(this.withdrawal_amount) == 0) {
          return Toast('提现金额不能为0')
        } else if (this.withdrawal_amount == '.') {
          this.$toast('请输入正确的金额')
          return
        }
        this.withdrawal_amount == '.'
        this.pay_password_show = true
      },
      goPage (path, query = {}) {
        this.$router.push({ path: path, query: query })
      },
      goBack () {
        this.$router.go(-1)
      }
    }
  }
</script>
<style lang="less">
  .agent-upload-div {
    .van-uploader__preview-image {
      width: 64px;
      height: 64px;
    }
  }

  .agent-withdraw-input-span {
    display: inline-block;
    flex: 1;

    .common-input {

      .input-div {
        height: 22px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #1B1A2E;
        line-height: 22px;
        text-indent: 4px;
      }
    }
  }
</style>
<style lang="less" scoped>
  .agent-withdraw-body {
    background: #F5F6F7;
    min-height: 100vh;
    overflow: hidden;

    .agent-withdraw-nav {
      position: fixed;
      top: 0;
      padding-top: 44px;
      background: #fff;
      background-size: 100% 240px;
      z-index: 3;
    }

    .agent-withdraw-text {
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #1B1A2E;
      line-height: 22px;

    }

    .agent-withdraw-first-div {
      margin: 100px 0 12px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 28px;
      padding: 15px 12px;
      background: #fff;

      div {
        &:nth-child(1) {
          height: 24px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }

        &:nth-child(2) {
          display: flex;
          align-items: center;

          img {
            width: 28px;
            height: 28px;
            margin-right: 9px;
          }

          span {
            height: 24px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }
      }

      .arrow-right {
        width: 16px;
        height: 16px;
      }
    }

    .agent-withdraw-div {
      background-color: #ffffff;
      padding: 21px 12px 0;
    }

    .agent-withdraw-input-div {
      margin: 32px 0 0px;
      padding-bottom: 10px;
      display: flex;
      position: relative;
      width: calc(100vw - 24px);

      &::before {
        content: '';
        width: calc(100vw - 24px);
        height: 1px;
        background: #EEEEEE;
        position: absolute;
        bottom: 0;
      }

      .agent-withdraw-input-symbol {
        height: 22px;
        font-size: 30px;
        font-family: Helvetica;
        color: #333333;
        line-height: 22px;
        vertical-align: bottom;
      }

      .all-withdraw-btn {
        white-space: nowrap;
        height: 24px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F9591B;
        line-height: 24px;
      }
    }

    .withdraw-text {
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FA8C16;
      line-height: 22px;
      padding: 25px 0 calc(100vh - 610px) 12px;
      background-color: #fff;
    }

    .custom-keyboard-div {
      display: flex;
      justify-content: space-between;

      .submit-btn {
        margin-top: 12px;
        width: 82px;
        height: 212px;
        background: #FC740C;
        border-radius: 4px;
        line-height: 212px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin-right: 12px;
      }
    }

    .account-pup-title {
      height: 21px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
      padding: 20px 0 30px 12px;
    }

    .account-item-div {
      padding-left: 12px;
      padding-right: 12px;
      margin-bottom: 22px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .account-left-div {
        display: flex;
        align-items: center;

        img {
          width: 27px;
          height: 27px;
          margin-right: 12px;
        }

        span {
          height: 24px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }

      }

      .account-right-div {
        display: flex;
        align-items: center;

        span {
          height: 24px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-right: 3px;
        }
      }

      .arrow-right {
        width: 16px;
        height: 16px;
      }
    }

    .agent-withdraw-bottom-btn {
      height: 48px;
      width: 32px;
      text-align: center;
      height: 22px;
      font-size: 16px;
      padding: 13px 156px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 22px;
      background: linear-gradient(90deg, #55A7AE 0%, #58C3B6 100%);
      border-radius: 8px;
      position: absolute;
      bottom: 7px;
      left: 16px;
      white-space: nowrap;
    }

    .agent-withdraw-bottom-btn-ios {
      bottom: 41px;
    }

    .agent-second-div {
      background-color: #fff;
      padding: 24px;
      margin: 12px 16px 32px;
      box-shadow: 0px 2px 12px 0px rgba(30, 43, 46, 0.08);
      border-radius: 8px;

      .agent-upload-div {
        margin-top: 16px;
        position: relative;

        .upload-permision {
          width: 64px;
          height: 64px;
          left: 0;
          top: 0;
          position: absolute;
          z-index: 2;
        }

        .upload-div {
          width: 64px;
          height: 64px;
          background: #F5F5F5;
          border-radius: 8px;

          img {
            display: inline-block;
            height: 12px;
            width: 12px;
            margin: 50% 0 0 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    .agent-three-div {
      margin: 0 16px;

      .agent-three-text {
        font-size: 14px;
        font-weight: 400;
        color: #8E939C;
        line-height: 22px;
        margin-top: 12px;

        span {
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #5391A7;
          line-height: 20px;
        }
      }
    }
  }
</style>